import { AxiosPromise } from 'axios';
import { Article } from '../../types/Article';
import { Category } from '../../types/Category';
import { libApiInstance } from '../axios';

//Categories
export function requestCategories(signal?: AbortSignal): AxiosPromise<Category[]> {
    return libApiInstance.get(`Help/Categories`, { signal });
}

export function requestCategoryById(id: number, signal?: AbortSignal): AxiosPromise<Category> {
    return libApiInstance.get(`Help/Categories/${id}`, { signal }); //TODO check endpoint /
}

//Articles
export function requestArticles(signal?: AbortSignal): AxiosPromise<Article[]> {
    return libApiInstance.get(`Help/Articles`, { signal });
}

export function requestArticlesByCategory(
    categoryId: number,
    signal?: AbortSignal,
): AxiosPromise<Article[]> {
    return libApiInstance.get(`Help/Articles/ByCategory/${categoryId}`, { signal });
}

export function requestArticleById(articleId: number, signal?: AbortSignal): AxiosPromise<Article> {
    return libApiInstance.get(`Help/Articles/${articleId}`, { signal }); //TODO check endpoint /
}

export function requestSearchArticles(
    search: string,
    signal?: AbortSignal,
): AxiosPromise<Article[]> {
    return libApiInstance.get(`Help/Articles/Search`, { signal, params: { query: search } });
}
